import Helpers from "@utils/Helpers";
import { Checkbox, Input, Timeline } from "antd";
import { useEffect, useState } from "react";

const CollapseHeader: React.FC<any> = ({
  index,
  activeKey,
  formExpUpdate,
  setFormExpUpdate,
  handleSetSelectedExperience,
  selectedExperience,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const isCollapseItemOpen = activeKey.includes(index.toString());
  const position: any[] = [];
  formExpUpdate[index].position.forEach((item: any, idx: number) => {
    const positionItem = {
      children: (
        <>
          <span>{formExpUpdate[index].position[idx].position_name}</span> -{" "}
          <span className="text-muted">
            {formExpUpdate[index].position[idx].working_time}
          </span>
        </>
      ),
      color: "#52b4b4",
    };
    position.push(positionItem);
  });

  useEffect(() => {
    const isExists = selectedExperience.includes(
      formExpUpdate[index].company_id
    );
    setIsChecked(isExists);
  }, [selectedExperience]);

  return (
    <div className="collapse-header">
      <div className="flex-shrink-0">
        <Checkbox
          checked={isChecked}
          onChange={(e) => {
            handleSetSelectedExperience(e.target.checked, formExpUpdate[index]);
          }}
        ></Checkbox>
      </div>
      <div className="collapse-header-info flex-grow-1">
        <div className="collapse-header-company">
          <Input
            className="fake-input"
            onChange={(e) => {
              setFormExpUpdate(e.target.value, "company_name", index);
            }}
            value={formExpUpdate[index].company_name}
          />
        </div>
        <div className="collapse-header-working-time">
          {Helpers.formattedDate(formExpUpdate[index].company_start_date)} -{" "}
          {Helpers.formattedDate(formExpUpdate[index].company_end_date)}
        </div>
      </div>
      {!isCollapseItemOpen && (
        <div
          className="collapse-header-timeline flex-grow-1 pt-2"
          style={{ maxWidth: "45%" }}
        >
          <Timeline items={position} />
        </div>
      )}
    </div>
  );
};

export default CollapseHeader;
